import { render, staticRenderFns } from "./BranchStudents.vue?vue&type=template&id=0dce8006&scoped=true&lang=pug&"
import script from "./BranchStudents.vue?vue&type=script&lang=ts&"
export * from "./BranchStudents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce8006",
  null
  
)

export default component.exports